import { ArrowUpOnSquareIcon } from '@heroicons/react/24/solid';
import React, { useEffect, useState } from 'react';
import { createAddOn, getDetailsAddOn, updateAddOn } from '../../../api/AddOnInteractor';
import { getVenueSchedule, getVenueDetail, bookVenueByAdmin, getListService } from '../../../api/VenueInteractor';
import { containsOnlyNumbers, showToast } from '../../../Utils';
import { useParams } from 'react-router-dom';
import DatePicker from '../DatePicker';
import { format, startOfToday } from 'date-fns';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

function CreateAddon(props) {
  const inputClass = "w-full text-xs bg-[#F5F5F5] rounded-lg py-2 px-6 focus:outline-none focus:border focus:border-primaryYellow focus:ring-1 focus:ring-primaryYellow"
  const textarea = "w-full h-24 resize-y text-xs bg-[#F5F5F5] rounded-lg py-2 px-6 focus:outline-none focus:border focus:border-primaryYellow focus:ring-1 focus:ring-primaryYellow"
  const hiddenFileInput = React.useRef(null);

  const [loading, setLoading] = useState(false)

  let [addOnIcon, setAddOnIcon] = useState(null)
  let [addOnIconUrl, setAddOnIconUrl] = useState("")
  let [sportType, setSportType] = useState("")
  let [addOnName, setAddOnName] = useState("")
  let [addOnPrice, setAddOnPrice] = useState("")
  let [addOnUnit, setAddOnUnit] = useState("")
  let [addOnDesc, setAddOnDesc] = useState("")
  let [addOnType, setAddOnType] = useState("")
  let [scheduleList, setScheduleList] = useState([])
  let [scheduleAddOn, setScheduleAddOn] = useState([])
  let [selectedDate, setSelectedDate] = useState(startOfToday())
  let [selectAll, setSelectAll] = useState(false)

  const addOnId = useParams()


  const onFileChange = (event) => {
    setAddOnIcon(event.target.files[0])
    setAddOnIconUrl(URL.createObjectURL(event.target.files[0]));
  }

  const handleClick = event => {
    hiddenFileInput.current.click();
  };


  const createAddonApi = () => {
    setLoading(true)

    const validateResult = validateForm()

    if (validateResult.isValid) {
      if (props.editMode) {
        console.log("sportType", sportType)
        //success
        updateAddOn(addOnId.addOnId, addOnIcon, addOnName, addOnUnit, addOnPrice, addOnDesc, addOnType, scheduleAddOn, sportType,
          //success
          (responseJSON) => {
            showToast("Success", "Update Success", "Add On updated successfully")
            // setTimeout(() => {
            //   window.location = '/addon'
            // }, 2000)
          },
          //failed
          (message) => {
            showToast("Error", "Create Failed", message)
          }
        )
      } else {
        createAddOn(
          addOnIcon, addOnName, addOnPrice, addOnUnit, addOnDesc, addOnType, scheduleAddOn, sportType,
          //success
          (responseJSON) => {
            showToast("Success", "Create Success", "Add On created successfully")
            setTimeout(() => {
              window.location = '/addon'
            }, 2000)
          },
          //failed
          (message) => {
            showToast("Error", "Create Failed", message)
          }
        )
      }
    } else {
      showToast("Error", "Failed", validateResult.validationMessage)
    }


  }

  const getDetailsAddOnApi = () => {
    getDetailsAddOn(addOnId.addOnId,
      //success
      (responseJSON) => {
        setAddOnName(responseJSON.name)
        setAddOnPrice(responseJSON.price)
        setAddOnUnit(responseJSON.unit)
        setAddOnDesc(responseJSON.note)
        setAddOnType(responseJSON.add_on_type)
        setSportType(responseJSON.sport_type)
        setAddOnIconUrl(process.env.REACT_APP_BASE_URL_IMAGE + responseJSON.image.url)
        const updatedSchedules = responseJSON.add_on_item_schedules
          .sort((a, b) => b.id - a.id)
          .map(element => ({
            ...element,
            _destroy: 0
          })).slice(0, 1200);
        setScheduleAddOn(updatedSchedules);
        console.log("responseJSON.add_on_item_schedules")
        console.log(responseJSON.add_on_item_schedules)
      },
      //failed
      (message) => {
        showToast("Error", "Get Failed", message)

      }
    )
  }

  const validateForm = () => {

    if (props.editMode !== true) {
      if (addOnIcon == null) {
        return {
          isValid: false,
          validationMessage: "Please insert addon image"
        }
      }
    }

    if (addOnUnit == "") {
      return {
        isValid: false,
        validationMessage: "Please insert addon unit"
      }
    }

    if ((addOnPrice == "") || (!containsOnlyNumbers(addOnPrice))) {
      return {
        isValid: false,
        validationMessage: "Please insert addon price (numbers only)"
      }
    }

    if (addOnName == "") {
      return {
        isValid: false,
        validationMessage: "Please input addon name"
      }
    }

    if (addOnType == "") {
      return {
        isValid: false,
        validationMessage: "Please input addon type"
      }
    }

    if (addOnDesc == "") {
      return {
        isValid: false,
        validationMessage: "Please input addon description"
      }
    }

    return {
      isValid: true,
      validationMessage: ""
    }

  }

  useEffect(() => {
    if ('addOnId' in addOnId) {
      getDetailsAddOnApi()
    }
  }, [])

  useEffect(() => {
    setSelectAll(scheduleList.length > 0 && scheduleList.every(item => isExistSchedule(item)));
  }, [selectedDate, scheduleList]);

  const onDaySelected = (selectedDate) => {
    const selectedDateString = format(selectedDate, 'yyyy-MM-dd')
    setSelectedDate(selectedDate)
    getScheduleApi(selectedDateString)
  }



  const getScheduleApi = (selectedDateString) => {
    getListService(1,
      (responseJSON) => {
        getVenueSchedule(responseJSON.venues[0].id, selectedDateString,
          (responseJSON) => {
            setScheduleList(responseJSON.times)
          },
          (message) => {
            showToast("Error", "Get Schedule Failed", message)
          }
        )
      },
      (message) => {
        showToast("Error", "Get Schedule Failed", message)
      }
    )
  }

  const handleToggleSchedule = (item) => {
    const formattedDate = format(selectedDate, 'yyyy-MM-dd');
    const startTime = item.hour.split(' - ')[0];
    const endTime = item.hour.split(' - ')[1];

    const existingIndex = scheduleAddOn.findIndex(
      (entry) =>
        entry.date_available === formattedDate &&
        entry.start_time === startTime &&
        entry.end_time === endTime
    );

    if (existingIndex === -1) {
      // If item doesn't exist, add it
      setScheduleAddOn([
        ...scheduleAddOn,
        {
          date_available: formattedDate,
          start_time: startTime,
          end_time: endTime,
          _destroy: 0,
        },
      ]);
    } else {
      const newSchedule = [...scheduleAddOn];
      if (newSchedule[existingIndex].id !== undefined) {
        newSchedule[existingIndex]._destroy = newSchedule[existingIndex]._destroy === 0 ? 1 : 0;
      } else {
        newSchedule.splice(existingIndex, 1);
      }
      setScheduleAddOn(newSchedule);
    }

    console.log(scheduleAddOn);
  };

  const isExistSchedule = (item) => {
    const formattedDate = format(selectedDate, 'yyyy-MM-dd');
    const startTime = item.hour.split(' - ')[0];
    const endTime = item.hour.split(' - ')[1];
    const existingIndex = scheduleAddOn.findIndex(
      (entry) =>
        entry.date_available === formattedDate &&
        entry.start_time === startTime &&
        entry.end_time === endTime
    );

    // Return false if not found OR if found but _destroy === 1
    if (existingIndex === -1) {
      return false;
    }

    return scheduleAddOn[existingIndex]._destroy === 0;
  };

  const allSelected = scheduleList.length > 0 && scheduleList.every(item => isExistSchedule(item));

  const someSelected = scheduleList.some(item => isExistSchedule(item));
  const indeterminate = someSelected && !allSelected;

  const handleSelectAll = () => {
    const isSelectAll = !selectAll; // Toggle the "select all" state
    const formattedDate = format(selectedDate, 'yyyy-MM-dd');
    let updatedSchedule = [...scheduleAddOn];

    scheduleList.forEach((item) => {
      const startTime = item.hour.split(' - ')[0];
      const endTime = item.hour.split(' - ')[1];

      const existingIndex = updatedSchedule.findIndex(
        (entry) =>
          entry.date_available === formattedDate &&
          entry.start_time === startTime &&
          entry.end_time === endTime
      );

      if (existingIndex === -1 && isSelectAll) {
        updatedSchedule.push({
          date_available: formattedDate,
          start_time: startTime,
          end_time: endTime,
          _destroy: 0,
        });
      } else if (existingIndex !== -1) {
        if (updatedSchedule[existingIndex].id !== undefined) {
          updatedSchedule[existingIndex]._destroy = isSelectAll ? 0 : 1;
        } else {
          if (!isSelectAll) {
            updatedSchedule.splice(existingIndex, 1);
          }
        }
      }
    });

    setScheduleAddOn(updatedSchedule);
    setSelectAll(isSelectAll); // Set the "select all" state to the new value
  };




  const renderSchedule = () => {
    return (
      <div className='flex flex-col px-1 grid grid-cols-2 gap-4 lg:grid-cols-3'>
        {scheduleList.map((item, index) => {
          return (
            <div key={index} onClick={(e) => { handleToggleSchedule(item) }} className={isExistSchedule(item) ? 'flex items-center justify-between w-full border border-primaryRed text-white text-sm rounded-lg pl-4 pt-4 pb-4 pr-2 cursor-pointer bg-primaryRed' : 'flex items-center justify-between w-full border border-primaryRed text-primaryRed text-sm rounded-lg pl-4 pt-4 pb-4 pr-2 cursor-pointer'}>
              <p className='font-medium'>{item.hour}</p>
              <span className=' flex items-center font-semibold'>
                {isExistSchedule(item) ?
                  <CheckCircleIcon className='w-6 text-white ml-2' />
                  :
                  <CheckCircleIcon className='w-6 text-gray-300 ml-2' />
                }
              </span>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className=' w-full bg-white rounded-2xl flex flex-col px-8 py-4'>
      <p className='text-lg my-4 text-left text-gray-800 font-semibold'>Buat Add On</p>

      <div className='flex flex-col lg:flex-row w-full lg:gap-x-4 gap-y-4'>

        <div className='w-full flex-[4] flex flex-col py-4 px-4 gap-y-2 items-center rounded-lg border-2 border-gray-200 border-dashed '>

          {addOnIconUrl == "" ?
            <img src='/ic_img.png' className='w-14' />
            :
            <img src={addOnIconUrl} className='w-24' />
          }


          <p className='text-sm  text-left text-gray-800 font-semibold'>Icon Add On</p>
          <p className='text-[10px]  text-center text-gray-500 font-semibold'>Silahkan Hubungi Tomo untuk minta dibuatkan
            Icon Ilustrasi Add On. Ukuran disarankan 85 x 85px</p>


          <input id="file-upload"
            ref={hiddenFileInput}
            onChange={(e) => { onFileChange(e) }}
            name="file-upload" type="file" class="sr-only" />
          <button onClick={handleClick} className='flex mt-2 items-center px-6 py-2 text-[10px] font-semibold text-white bg-primaryRed rounded-lg'>
            <ArrowUpOnSquareIcon className='w-5 mr-2' />
            Unggah Icon
          </button>

        </div>


        <div className='w-full flex-[6] flex flex-col gap-y-4 py-4 px-4 gap-y-4 items-center rounded-lg border-2 border-gray-200 border-dashed '>
          <select className={"w-full text-gray-700 flex w-1/2 text-[10px]" + inputClass} placeholder='Pilih Jenis Olahraga'
            onChange={(e) => {
              setSportType(e.target.value)

              console.log("sportType1", e.target.value)
              console.log("sportType2", sportType)
            }} value={sportType}>
            {/* <option>Futsal</option>
                <option>Soccer</option>
                <option>Badminton</option> */}
            <option>--- Pilih Jenis Olahraga ---</option>
            <option>Padel</option>
            <option>Badminton</option>
            <option>Futsal</option>
            <option>Mini Soccer</option>
            <option>Soccer</option>
            <option>Tennis</option>
            <option>Basketball</option>
          </select>
          <input onChange={(e) => { setAddOnName(e.target.value) }} value={addOnName} type="text" className={" text-[10px] " + inputClass} placeholder='Input Nama Add On' />
          <select className={"w-full text-gray-700 flex w-1/2 text-[10px] " + inputClass} placeholder='Pilih Jenis'
            onChange={(e) => {
              setAddOnType(e.target.value)
            }} value={addOnType}
          >
            <option>--- Pilih Jenis Addon ---</option>
            <option value="Barang">Barang</option>
            <option value="Jasa">Jasa</option>
          </select>
          <div className='flex w-full gap-x-2'>
            <input onChange={(e) => { setAddOnPrice(e.target.value) }} value={addOnPrice} type="text" className={"w-1/2 text-[10px] " + inputClass} placeholder='Harga Satuan' />
            <select className={"w-full text-gray-700 flex w-1/2 text-[10px]" + inputClass} placeholder='Pilih Addon Unit'
              onChange={(e) => {
                setAddOnUnit(e.target.value)

                console.log("addOnUnit", e.target.value)
                console.log("addOnUnit", addOnUnit)
              }} value={addOnUnit}>
              {/* <option>Futsal</option>
                <option>Soccer</option>
                <option>Badminton</option> */}
              <option>--- Pilih Addon Unit ---</option>
              <option>Hour</option>
              <option>Booking</option>
              <option>Pcs</option>
              <option>S</option>
              <option>M</option>
              <option>L</option>
              <option>XL</option>
            </select>
          </div>
          <textarea onChange={(e) => { setAddOnDesc(e.target.value) }} value={addOnDesc} className={"text-[10px] " + textarea} placeholder='Keterangan' />

        </div>

      </div>

      {/* { addOnType === "Jasa" && ( */}
      <div className="mt-4 w-full flex gap-x-4 py-4 px-4 rounded-lg border-2 border-gray-200 border-dashed">
        <div className="flex-[4]">
          <DatePicker onDaySelected={onDaySelected} />
        </div>
        <div className="flex-[6]">
          <div className='flex flex-row'>
            <div className="flex flex-1 mr-2 mb-2">
              <p className="text-right font-bold m-2">Jadwal Ketersediaan</p>
            </div>
            <div className="flex flex-1 justify-end items-center mr-2 mb-2">
              <p className="text-right font-bold m-2">Pilih semua</p>
              <input
                id="checkbox-all-search"
                type="checkbox"
                className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                checked={selectAll}
                onChange={handleSelectAll}
                ref={(el) => {
                  if (el) {
                    el.indeterminate = indeterminate;
                  }
                }}
              />
              <label htmlFor="checkbox-all-search" className="sr-only">checkbox</label>
            </div>
          </div>
          {renderSchedule()}
        </div>
      </div>
      {/* )} */}

      <div className='w-full flex justify-end'>
        <button onClick={() => { createAddonApi() }} className={`cursor-pointer flex mt-4 w-fit items-center px-8 py-3 text-[10px] font-semibold text-white bg-primaryRed rounded-lg ${loading ? '' : ''}`}>
          {/* {loading ? 'Loading' : (
            <> */}
          <img src='/ic_send.png' className='w-4 mr-2' />
          SUBMIT ADD ON
          {/* </> */}
          {/* )} */}
        </button>
      </div>


    </div>
  );
}

export default CreateAddon;